import React from 'react'

import GraphImg from './img/graph.png'

export const TabPlan: React.FC = () => {
    return (
        <div className="flex flex-col md:grid grid-cols-2 gap-4">
            <div className="card_item card_item_dark flex items-end">
                <p className="text-4xl text-[#1051F5] font-bold">
                    Не нужно
                    <br />
                    больше
                    <br />
                    заполнять ЕИС
                </p>
            </div>

            <div className="card_item card_item_dark row-span-2">
                <h2>Модуль NOXSYS. План закупки</h2>
                <div>
                    <ul>
                        <li className="!mt-6">
                            <b>
                                Автоматическая консолидация позиций плана
                                закупки в единый план закупки организации
                            </b>
                            <br />
                            Встроенная валидация на соблюдение нацрежима, на
                            правильность формы и способа закупки
                        </li>
                        <li className="!mt-6">
                            <b>
                                Контроль закупаемых ТРУ на соблюдение
                                национального режима
                            </b>
                            <br />
                            Автоматическое формирование закупочной документации
                            — план закупки, извещение, документация, протоколы
                        </li>
                        <li className="!mt-6">
                            <b>Отправка плана закупки в ЕИС</b>
                            <br />
                            Вы можете загрузить заявки и планы закупок из Excel
                            в систему, а также выгружать отчеты, реестры и
                            аналитику в привычном вам формате
                        </li>
                        <li className="!mt-6">
                            <b>Нейросеь, которая рекомендует код ОКПД2</b>
                            <br />
                            Встроенный справочник с использованием нейросетевых
                            технологий, которая рекомендует код ОКПД2 и
                        </li>
                    </ul>
                </div>
            </div>
            <div className="card_item card_item_dark !pb-0">
                <h2>Интерактивные реестры</h2>
                <img src={GraphImg} />
            </div>
        </div>
    )
}
